import { ActionContext } from 'vuex';
import { ConfigMutations } from './mutations';
import { AppConfig } from '@/models/AppConfig';
import { AppState as TechnicianAppState } from '@/models/TechnicianAppState';
import { AppState as SkillAssessmentAppState } from '@/models/SkillAssessmentAppState';

type AppState = TechnicianAppState | SkillAssessmentAppState;

export const ConfigActions = {
	INIT: 'INIT'
}

export default {
	[ConfigActions.INIT] (context: ActionContext<AppConfig, AppState>) {
		context.commit(ConfigMutations.REMOVE_NOTIFICATION);
	}
}
